import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setVisible(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('cookieConsentTimestamp', new Date().toISOString());
    setVisible(false);
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted',
      'ad_storage': 'granted'
    });
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    localStorage.setItem('cookieConsentTimestamp', new Date().toISOString());
    setVisible(false);
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied',
      'ad_storage': 'denied'
    });
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-container">
      <div className="cookie-consent-content">
        <h3>Cookie Consent</h3>
        <p>
          We use cookies to enhance your experience on our website. By continuing to use our site, you consent to our use of cookies in accordance with our 
          <Link to="/privacy-policy"> Privacy Policy</Link>.
        </p>
        <p>
          We use necessary cookies for essential site functions and analytics cookies to understand how you use our website and improve our services.
        </p>
        <div className="cookie-consent-buttons">
          <button 
            className="cookie-button secondary" 
            onClick={acceptNecessary}
          >
            Accept Necessary Only
          </button>
          <button 
            className="cookie-button primary" 
            onClick={acceptAll}
          >
            Accept All Cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 